"use strict";
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
class MaydayFetchInstance {
    constructor(TokenService, baseURL) {
        this.TokenService = TokenService;
        this.baseURL = baseURL;
    }
    fetchStream(url, options) {
        return __asyncGenerator(this, arguments, function* fetchStream_1() {
            const decoder = new TextDecoder('utf-8');
            const accessToken = this.TokenService.get();
            options.headers['Authorization'] = 'Bearer ' + accessToken;
            let response = yield __await(fetch(`${this.baseURL}/${url}`, options));
            if (response.status === 401) {
                const accessToken = yield __await(this.TokenService.refreshToken());
                options.headers['Authorization'] = 'Bearer ' + accessToken;
                response = yield __await(fetch(`${this.baseURL}/${url}`, options));
            }
            if (!response || !response.body)
                return yield __await(void 0);
            const reader = response.body.getReader();
            let rawString = '';
            let loading = true;
            while (loading) {
                const { value, done } = yield __await(reader.read());
                loading = !done;
                const rawResponse = decoder.decode(value);
                rawString += rawResponse;
                while (true) {
                    const lineBreak = rawString.search('\n');
                    if (lineBreak == -1) {
                        break;
                    }
                    yield yield __await(JSON.parse(rawString.slice(0, lineBreak + 1)));
                    rawString = rawString.slice(lineBreak + 1);
                }
            }
            if (rawString) {
                yield yield __await(JSON.parse(rawString));
            }
        });
    }
}
exports.default = MaydayFetchInstance;
